import BaseModal from "@reusables/Modals/BaseModal";
import { useDeleteCurrencyMutation } from "@redux/features/currencies/currenciesApi";
import { Currency } from "@/types/general";
import { useTranslation } from "react-i18next";
import BaseButton from "@reusables/BaseButton";
import { toast } from "react-toastify";
import {isErrorWithMessage} from "@redux/api/query";

interface DeletionModalProperties {
    isOpen: boolean;
    currency?: Currency.Root;
    onClose: () => void;
}

export default function DeletionModal(props: DeletionModalProperties) {
    const { t } = useTranslation("", { keyPrefix: "settings.general.currencies.modals.deletion" });

    const [deleteCurrency, { isLoading: isDeletionLoading }] = useDeleteCurrencyMutation();

    return (
        <BaseModal isOpen={props.isOpen} onClose={props.onClose} width={700} padding="56px" isLoading={isDeletionLoading}>
            <div className="space-y-[32px]">
                <div className="text-xl font-semibold text-center text-accent">{t("heading")}</div>
                <div className="text-center text-accent">{t("subheading")}.</div>
                <div className="grid grid-cols-2 gap-[16px]">
                    <BaseButton text={t("buttons.cancel")} size="md" primaryOutlined onClick={props.onClose} />
                    <BaseButton
                        text={t("buttons.delete")}
                        size="md"
                        onClick={() => {
                            if (props.currency) {
                                deleteCurrency(props.currency.id)
                                    .unwrap()
                                    .then((resp) => {
                                        toast.success(t("responses.success"));
                                    })
                                    .catch((e) => {
                                        if(isErrorWithMessage(e)){
                                            toast.error(e.message);
                                        } else {
                                            toast.error(t("responses.error"));
                                        }
                                    })
                                    .finally(() => props.onClose());
                            }
                        }}
                    />
                </div>
            </div>
        </BaseModal>
    );
}